export class ValidateFileNameExistResultDto {
    fileName: string;
    fileNameExist: boolean;
    overwriteFileName: string;
}
